<template>
    <home-template>
<v-tabs icons-and-text centered>
    <v-tabs-slider color="teal"></v-tabs-slider>
    <v-tab href="#tab-1">
       <div style="color:teal">Amigos</div>
      <v-icon color="teal">person</v-icon>
    </v-tab>
    <v-tab href="#tab-2">
      <v-icon>people</v-icon>
    </v-tab>
    <v-tab href="#tab-3">
      <v-icon>search</v-icon>
    </v-tab>
    <v-tab-item id="tab-1">
        <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
        <v-list>
            <br/>
            <template>
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="https://vuetifyjs.com/static/doc-images/lists/1.jpg">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Fulano de tal e costa</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
            </template>
            <template>
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="https://vuetifyjs.com/static/doc-images/lists/2.jpg">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Ciclano de tal e lima</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
            </template>
            <template>
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="https://vuetifyjs.com/static/doc-images/lists/3.jpg">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Beltrana de tal e pera</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
            </template>
            <br />
            <v-subheader>Pendentes</v-subheader>
            <template>
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="https://vuetifyjs.com/static/doc-images/lists/5.jpg">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Beltrana de tal e pera</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
            </template>
            <template>
                <v-list-tile avatar>
                <v-list-tile-avatar>
                    <img src="https://vuetifyjs.com/static/doc-images/lists/3.jpg">
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>Beltrano de tal e pera</v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
                <v-divider inset></v-divider>
            </template>
        </v-list>
    </v-flex>
        </v-layout>
    <v-card>
        <v-card-text style="height: 50px; position: relative">
        </v-card-text>
        <v-btn
              absolute
              dark
              fab
              top
              right
              color="orange"
            >
              <v-icon>add</v-icon>
      </v-btn>
    </v-card>
    </v-tab-item>
    <v-tab-item id="tab-2">
      <v-card flat>
        <v-card-text></v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item id="tab-3">
      <v-card flat>
        <v-card-text>tres</v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs>
    </home-template>
</template>

<script>
import HomeTemplate from '@/components/pages/templates/HomeTemplate'
export default {
    name: 'FriendsPage',
    components: {
        HomeTemplate
    },
    data: () => {
        items: [
          { header: 'Today' },
          { avatar: '/static/doc-images/lists/1.jpg', title: 'Brunch this weekend?', subtitle: "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?" },
          { divider: true, inset: true },
          { avatar: '/static/doc-images/lists/2.jpg', title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>', subtitle: "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend." },
          { divider: true, inset: true },
          { avatar: '/static/doc-images/lists/3.jpg', title: 'Oui oui', subtitle: "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?" }
        ]
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/FriendsPage.vue